import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomeScreen from '../screens/HomeScreen';
import UnitScreen from '../screens/UnitScreen';
import LessonScreen from '../screens/LessonScreen';
import QuizScreen from '../screens/QuizScreen';
import SimulationScreen from '../screens/SimulationScreen';
import ProgressScreen from '../screens/ProgressScreen';
import ConceptMapScreen from '../screens/ConceptMapScreen';

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/unit/:unitId" element={<UnitScreen />} />
        <Route path="/unit/:unitId/concept/:conceptId/lesson" element={<LessonScreen />} />
        <Route path="/unit/:unitId/concept/:conceptId/quiz" element={<QuizScreen />} />
        <Route path="/unit/:unitId/concept/:conceptId/simulation" element={<SimulationScreen />} />
        <Route path="/progress" element={<ProgressScreen />} />
        <Route path="/concept-map" element={<ConceptMapScreen />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
